import DisplayMode from './displaymode'

export default DisplayMode
